module.exports = __webpack_public_path__ + "media/images/emblems/Krattigen-coat_of_arms-fd8f5376a2721a117a3848b66666bb44.svg";